<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
		[class.text-danger]="controls?.errors != null"> *</span></label>
<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
	[class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">
	<tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
		[tooltipMessage]="tooltipMessage" [submitted]="submitted"></tooltip-message>
	<div class="d-flex">
		<div class="w-100">
			<input #inputText type="text" class="form-control form-control-sm text-right"
				[class.is-invalid]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
				[(ngModel)]="value" [disabled]="disabled" [readonly]="readonly" [mask]="format" thousandSeparator=","
				(blur)="onBlur($any($event.target).value)" (input)="onInput($any($event.target).value)"
				(focusout)="onFocusOut($any($event.target).value)" [autocomplete]="autocomplete" [placeholder]="placeholder"
				(focus)="onFocus($any($event.target).value)" [attr.maxLength]="maxLength" (keyup.enter)=" enterKeyUp()"
				(keyup.ArrowUp)=" arrowUpKeyUp()" [ngClass]="setNgClass" [class.bold]="bold">
		</div>
		<div class="bd-highlight" *ngIf="btnEnable">
			<button type="button" class="btn btn-info p-0 rounded-0 h-100" (click)="clickEnable()">
				<i class="fa fa-check text-white px-1" [matTooltip]="'Habilitar'"
					matTooltipClass="bg-info"></i></button>
		</div>
	</div>
</div>
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
	[tooltipMessage]="tooltipMessage" [submitted]="submitted"></error-message>